import Dropzone from 'react-dropzone';
import styled from 'styled-components/macro';

import { sizes } from '../../styles/vars';

const StyledDropzone = styled(Dropzone)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
  margin: ${sizes.blockPaddingY} 0;
  padding: ${sizes.blockPaddingX};
  background-color: #1a1616;
  border-color: #1a1616;
  text-align: center;
  color: #fff;
  cursor: pointer;
  font-size: 18px;
`;

export default StyledDropzone;
